import { Card } from 'react-bootstrap';
import { FC, useState } from 'react';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { houseToHouseServices } from 'src/services';
import { Hr, UsersSelector } from 'src/components/_commons';
import { typeUser } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    users: typeUser[] | null;
};

export const HTHAssignmentsByUser: FC<propsType> = ({ users }) => {
    const [usersToShow, setUsersToShow] = useState<typeUser[]>([]);;

    return (
        <div>
            <div className={'mt-5'}>
                {!!users?.length &&
                    <UsersSelector
                        setUsersToShow={setUsersToShow}
                        users={users}
                        usersToShow={usersToShow}
                    />
                }
            </div>
            <div className={'container'}>
                <div className={'row justify-content-center'}>
                    {usersToShow?.sort((u1, u2) => u1.email.localeCompare(u2.email)).map(u =>
                        <User key={u.id}
                            u={u}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

type propsType1 = {
    u: typeUser;
};

const User: FC<propsType1> = ({ u }) => {
    const [toAssign, setToAssign] = useState(0);
    const [toUnassign, setToUnassign] = useState(0);
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();

    const assign = async (): Promise<void> => {
        dispatch(showLoadingModalReducer());
        const response = await houseToHouseServices.AssignTerritory(u, toAssign, null, false);
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
            return;
        }
        setToAssign(0);
    }

    const unassign = async (): Promise<void> => {
        dispatch(showLoadingModalReducer());
        const response = await houseToHouseServices.AssignTerritory(u, null, toUnassign, false);
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
            return;
        }
        setToUnassign(0);
    }

    const unassignAll = (): void => {
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: '¿Desasignar todos?',
            message: `Se van a desasignar todos los territorios de Casa en Casa de ${u.email}`,
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await houseToHouseServices.AssignTerritory(u, null, null, true);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                    return;
                }
                setToAssign(0);
            }
        }));
    }

    return (
        <div className={'col-auto'}>
            <Card className={isDarkMode ? 'bg-dark text-white' : ''}
                style={{
                    backgroundColor: '#f6f6f8',
                    margin: '60px auto 0 auto',
                    width: isMobile ? '95%': '400px'
                }}
            >
                <Card.Body style={{ padding: '20px' }}>
                    <Card.Title className={'text-center p-4'}>
                        <div style={{ fontSize: isMobile ? '1.2rem' : '1.6rem' }}>
                            {u.name} {u.lastName}
                        </div>
                        <div>
                            {u.email}
                        </div>
                    </Card.Title>
                    <Hr />
                    <div style={{ fontWeight: 500, fontSize: '1.2rem', textAlign: 'center' }}>
                        Territorios asignados: &nbsp;
                        {!!u.hthAssignments?.length ?
                            u.hthAssignments.map(a =>
                                <span key={a.id} className={'d-inline-block'}>
                                    {a.territoryNumber} &nbsp;
                                </span>
                            )
                            :
                            <span> ninguno </span>
                        }
                    </div>
                    <div className={'text-center p-2'}>
                        <div style={{ marginTop: '12px' }}>
                            <input type={'number'}
                                className={'form-control d-inline-block'}
                                style={{ width: '70px' }}
                                min={1}
                                value={toAssign || ''}
                                onChange={e => setToAssign(parseInt(e.target.value) || 0)}
                                onKeyDown={e => e.key === 'Enter' && !!toAssign ? assign() : null}
                            />
                            &nbsp;&nbsp;
                            <button className={'btn btn-general-blue'}
                                style={{ width: '102px' }}
                                onClick={assign}
                                disabled={!toAssign}
                            >
                                &nbsp; Asignar &nbsp;
                            </button>
                        </div>
                        <div style={{ marginTop: '12px' }}>
                            <input type={'number'}
                                className={'form-control d-inline-block'}
                                style={{ width: '70px' }}
                                min={1}
                                value={toUnassign || ''}
                                onChange={e => setToUnassign(parseInt(e.target.value) || 0)}
                                onKeyDown={e => e.key === 'Enter' && !!toUnassign ? unassign() : null}
                            />
                            &nbsp;&nbsp;
                            <button className={'btn btn-general-blue'}
                                onClick={unassign}
                                disabled={!toUnassign}
                            >
                                Desasignar
                            </button>
                        </div>
                        {!!u.hthAssignments?.length &&
                            <div style={{ marginTop: '22px' }}>
                                <button className={'btn btn-general-blue'}
                                    onClick={unassignAll}
                                >
                                    Desasignar todos
                                </button>
                            </div>
                        }
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
}
